import { render, staticRenderFns } from "./MeetingMaterial.vue?vue&type=template&id=3796749e"
import script from "./MeetingMaterial.vue?vue&type=script&lang=js"
export * from "./MeetingMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports